import './App.css';
import { publicRoutes, protectedRoutes } from './Routes/routes';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './Utils/ScrollToTop';
import ProtectedRoutes from './Routes/protectedRoutes';
import PublicRoutes from './Routes/publicRoutes';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';
function App() {
  return (
    <Router>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={5}
      ></ToastContainer>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<ProtectedRoutes />}>
            {protectedRoutes.map((route) => {
              return (
                <>
                  <Route path={route.path} element={route.component} />
                </>
              );
            })}
          </Route>

          {publicRoutes.map((route) => {
            return (
              <Route path={route.path} element={<PublicRoutes />}>
                <Route path={`/${route.path}`} element={route.component} />
              </Route>
            );
          })}
        </Routes>
      </ScrollToTop>
    </Router>
  );
}

export default App;
